










import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import Files from "@/components/Files.vue";

@Component({
  components: {
    Files
  }
})
export default class SearchView extends Vue {
  public query: string = "";
  public tags: string = "";

  public load() {
    const queryQuery = this.$route.query;

    this.query = queryQuery.query as string;
    this.tags = queryQuery.tags as string;

    if (this.query === "") {
      this.$router.push("documents");
    }
  }

  @Watch("$route.query.tags")
  public reloadForTags(value: any, oldValue: any) {
    this.load();
  }

  @Watch("$route.query.query")
  public reloadForQuery(value: any, oldValue: any) {
    this.load();
  }

  private mounted() {
    this.load();
  }
}
